/**
 * Customers module
 *
 * Registers Vue components contributed by this module into the global
 * application (Hooks/Widgets slot resolution, etc.). Auto-loaded by the
 * admin theme's Modular via `import.meta.glob('/src/ * /index.ts')`.
 */

import { App } from 'vue';

import ReservationCustomerLink from '@src/Customers/Pages/Widgets/ReservationCustomerLink.vue';

export const setup = (app: App<Element>): void => {
    app.component('CustomersReservationLink', ReservationCustomerLink);
};
